<template>
  <VSpinner v-if="!product" class="offset-top-16 offset-bottom-17" />
  <article v-else>
    <div id="PRODUCT_ADMINISTRATION_CONFIRMATION_IN_PROGRESS" class="container-fixed">
      <VProgress v-if="flags.progressBarEnabled" class="offset-top-2 offset-bottom-2" :steps="steps" active="substore.progress_confirmation" />

      <VSection cluster label="substore.administration_in_progress">
        <p v-html="product.texts.productConfirmation"><!-- #95 --></p>
        <p v-html="product.texts.productConfirmationBeforeButtons"><!-- #99 --></p>

        <!-- #100 -->
        <p>
          <span v-for="(b, index) in product.productDescription.buttons" :key="index" class="offset-right-1">
            <a v-if="b.resourcePath" :href="b.url" class="center" target="_blank"><img :src="`delegates/product/content/${b.resourcePath}`" :alt="b.alt"/></a>
            <a v-else :href="b.url" class="btn btn-primary btn-brand center" target="_blank">{{ b.alt }}</a>
          </span>
        </p>

        <p v-html="product.texts.productConfirmationAfterButtons"><!-- #101 --></p>
      </VSection>

      <section class="offset-top-2 pull-right offset-right-1 button-bar">
        <router-link class="btn btn-default btn-brand" :to="{ name: STOCK }">
          {{ $t('common.navigation_STOCK') }}
        </router-link>
      </section>
    </div>

    <div class="container-fixed offset-top-6">
      <VFootnotes :footnotes="footnotes" />
    </div>
  </article>
</template>

<script>
import { mapGetters } from 'vuex';
import Proxy from '@/proxies/OrderConfirmationProxy';
import InProgressTransformer from '@/transformers/ProductOrderConfirmationInProgressTransformer';
import Footnotes from '@/utils/Footnotes';
import TitleMixin from '@/mixins/title';
import OrderStepsMixin from '@/mixins/orderSteps';
import VSpinner from '@/components/Spinner';
import VSection from '@/components/Section';
import { STOCK } from '@route-types';

export default {
  name: 'ProductAdministrationConfirmation',

  components: {
    VSpinner,
    VSection,
    VProgress: () => import('@/components/Progress'),
    VFootnotes: () => import('@/components/UI/Footnotes'),
  },

  mixins: [TitleMixin, OrderStepsMixin],

  props: {
    subscriptionTemplateId: {
      type: String,
      required: true,
    },

    uniqueSubscriptionId: {
      type: String,
      required: true,
    },

    inProgress: {
      type: String,
      required: false,
      default: null,
    },
  },

  data() {
    return {
      STOCK,
      transformer: null,
      product: null,
      footnotes: null,
      flags: {
        progressBarEnabled: null,
      },
    };
  },

  computed: {
    ...mapGetters('system', ['hasAccessCatalogue', 'hasAccessStockOverview']),

    confirmationInProgress() {
      return !!this.inProgress;
    },
  },

  async created() {
    const response = await new Proxy({
      optin: false,
      confirmationInProgress: true,
    }).find(this.subscriptionTemplateId);

    if (response.head.fault !== null) throw new Error(response.head.fault);

    Object.keys(this.flags).forEach(key => {
      this.flags[key] = response.data[key];
    });

    this.footnotes = new Footnotes();

    this.product = InProgressTransformer.fetch(response.data.product, this.footnotes);
  },
};
</script>

<style scoped>
.button-bar > span {
  position: relative;
  top: 1px;
  display: inline-block;
}
.center {
  position: relative;
  vertical-align: top;
}
</style>
